import { render, staticRenderFns } from "./scopecompanyproduct-add-or-update.vue?vue&type=template&id=60c8c96e&"
import script from "./scopecompanyproduct-add-or-update.vue?vue&type=script&lang=js&"
export * from "./scopecompanyproduct-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports